import React from "react";
import noImageLogo from "./user_logo.png";

export function UserCardLogo({ imgPreview, onChange, onClear }) {

    return (
        <div className="form-group oct_auth-user-logo-field">
            <div className="oct_auth-user-logo-wrap">
                <div className="oct_auth-user-logo-preview">
                    <img src={imgPreview || noImageLogo}
                        className="user-img-preview img-circle elevation-2 oct_auth-user-avatar"
                        alt="User Img" />
                </div>
                <div className="oct_auth-user-logo-actions">
                    <label htmlFor="file-upload" className="logo-file-upload oct_auth-user-upload-btn">
                        Choose profile image
                    </label>
                    {imgPreview &&
                        <label className="logo-file-upload oct_auth-user-upload-btn oct_auth-user-upload-btn-clear" onClick={onClear}>Clear</label>
                    }
                </div>
                <input id="file-upload" className="oct_display-none"
                    type="file"
                    onChange={onChange}
                    accept=".jpg, .jpeg, .png" />
            </div>
        </div>
    )

}
